/**
 * mulberry32 — tiny deterministic 32-bit PRNG. Mirrored bit-for-bit by
 * backend/internal/combat/rng.go so seeded battles replay identically.
 */
export function nextU32(state: number): [value: number, next: number] {
  const s = (state + 0x6d2b79f5) >>> 0;
  let t = s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return [(t ^ (t >>> 14)) >>> 0, s];
}

/** Stateful convenience wrapper (AI, cosmetics). Combat uses nextU32 on immutable state. */
export class Rng {
  constructor(private state: number) {
    this.state = state >>> 0;
  }

  u32(): number {
    const [v, s] = nextU32(this.state);
    this.state = s;
    return v;
  }

  /** Uniform float in [0, 1). */
  float(): number {
    return this.u32() / 4294967296;
  }

  int(maxExclusive: number): number {
    return this.u32() % maxExclusive;
  }

  pick<T>(items: readonly T[]): T {
    const item = items[this.int(items.length)];
    if (item === undefined) throw new Error('pick from empty list');
    return item;
  }

  get seed(): number {
    return this.state;
  }
}

export function randomSeed(): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] ?? 1;
}
